import type { Tunables } from './tunables';

/**
 * World space: 1 unit = 1 yard, y up, field centred on the origin.
 * The offense always attacks toward negative z; its own goal line is at +z.
 * ballOn is yards from the offense's own goal line (0 to 100).
 */
export function playingLength(t: Tunables): number {
  return t.field.lengthYards - 2 * t.field.endZoneYards;
}

export function ballOnToZ(ballOn: number, t: Tunables): number {
  return playingLength(t) / 2 - ballOn;
}

/** Converts a formation slot (x right, y downfield, relative to the ball) to world x and z. */
export function slotToWorld(slot: { x: number; y: number }, ballOn: number, t: Tunables): { x: number; z: number } {
  return { x: slot.x, z: ballOnToZ(ballOn, t) - slot.y };
}
